import { Routes, Route, useLocation } from "react-router-dom";
import {  lazy, Suspense, useContext } from "react";
import "./App.css";

import Navbar from "./Components/Navbar.js";
import { Toaster } from "sonner";
import { appRoutes } from "./Routes/appRoutes.js";
import AppLoader from './Components/loaders/AppLoader';
import ErrorPage from './Components/feedback/ErrorPage';

import ProfileCard from './features/profile/components/ProfileCard';
import ProfileInfo from './features/profile/components/ProfileInfo';
import Settings from './features/profile/components/Settings';
import Profile from './pages/Profile';
import Liked from './features/recipes/components/Liked';
import Recipe from './features/recipes/components/Recipe';
import ProtectedRoute from "./features/auth/components/ProtectedRoute.js";
import AuthContext from "./app/Context/AuthContext.js";
const AddRecipe=lazy(()=>import("./pages/AddRecipe.js"))



function App() {
  const {isServerDown}=useContext(AuthContext)
let location = useLocation()
const hideLayoutRoutes=['/login','/signup','/forgetpassword']
const hideLayout = hideLayoutRoutes.includes(location.pathname.toLocaleLowerCase())
if(isServerDown) return <ErrorPage code={500} message="Internal Server Error" description="   Something went wrong while fetching your delicious recipes.
          Our kitchen servers might be overheating 🍳"></ErrorPage>
  return (
    <>
    {!hideLayout && <Navbar></Navbar>}
     <Toaster
  theme="dark"
  toastOptions={{
    style: {
      background: "#111827",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: "14px",
    }
  }}
/>
         <Suspense fallback={<AppLoader></AppLoader>}>
        <Routes>
          {appRoutes.map((route)=>{
            return   <Route key={route.path}  path={route.path} element={route.element} />
          })}
         <Route path="/profile" element={<ProtectedRoute />}>
  <Route element={<Profile />}>
    <Route index element={
      <div className="grid max-w-7xl lg:grid-cols-[300px_1fr] mx-auto gap-6 px-4">
        <ProfileCard />
        <ProfileInfo />
      </div>
    } />

    <Route path="recipes" element={<Recipe />} />
    <Route path="liked-recipes" element={<Liked />} />
    <Route path="settings" element={<Settings />} />
  </Route>
</Route>
<Route path="/addRecipe" element={<ProtectedRoute/>}>
<Route index element={<AddRecipe></AddRecipe>}/>
</Route>
        
    

        </Routes></Suspense>
    </>
  );
}

export default App;
